import { Link } from "react-router-dom";
import { Badge, Button } from "antd";
import { Menu as MenuIcon, X as CloseIcon } from "lucide-react";
import { useCart } from "../../context/UserCartContext";
import { useSideMenu } from "../../context/SideMenuContext";
import UserCart from "../../pages/cart/UserCart";
import logo from "../../assets/logo.svg";
import SideMenu from "../Menu/SideMenu";
import TopAnnouncement from "../Announcement/Top.jsx";
import useFetchAnnouncement from "../../hooks/useFetchAnnouncement.js";

const Header = () => {
    const { cart } = useCart();
    const { isOpen, toggleMenu } = useSideMenu();
    const cartCount = cart.reduce((total, item) => total + item.qty, 0);
    const { announcement } = useFetchAnnouncement();

    const hasVisibleAnnouncement = announcement?.some(announcement => announcement.is_visible);

    return (
        <>
            {hasVisibleAnnouncement && <TopAnnouncement />}

            <div id="header" className="sticky z-1001 top-0 bg-white border-b border-gray-100 px-6">
                <div className="flex items-center justify-between h-16 w-full">
                    <div className="flex-1">
                        <Button
                            type="link"
                            size="middle"
                            icon={
                                isOpen ?
                                    <CloseIcon color="black" size={32} strokeWidth={1} /> :
                                    <MenuIcon color="black" size={32} strokeWidth={1} />
                            }
                            onClick={toggleMenu}
                        />
                    </div>

                    <div className="flex-1 flex justify-center">
                        <Link to="/">
                            <img src={logo} alt="Logo" className="w-24 h-24 cursor-pointer" />
                        </Link>
                    </div>

                    <div className="flex-1 flex justify-end items-center gap-2">
                        <Badge color="black" count={cartCount}>
                            <UserCart />
                        </Badge>
                    </div>
                </div>
                <SideMenu />
            </div>
        </>
    );
};

export default Header;